(async function () {
  var cartCookie = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
  const cookieExpiry = new Date(
    Date.now() + 30 * 24 * 60 * 60 * 1000
  ).toUTCString();
 
  if (cartCookie) {
    document.cookie =
      "cart=" +
      cartCookie[1] +
      `; Domain=.theayurvedaexperience.fr; expires=${cookieExpiry}; Path=/; SameSite=Lax;`;
  }
})();